import { ActionTitle } from "@/components/actionTitle/ActionTitle";
import { ActionTitleActions } from "@/components/actionTitle/ActionTitleActions";
import { useActiveProject } from "@/features/project/ActiveProject";
import { useQuotationSearchByCustomerId } from "@repo/api";
import { ListView, ListViewItem, createNewIcon, plusIcon } from "@repo/skapa";
import { t } from "@repo/translation";
import {
  Line,
  PaddedContainer,
  SectionContainer,
  useCustomer,
  useSettings,
} from "@repo/ui";
import { hasItems, trackAnalytics } from "@repo/utils";
import { useState } from "react";

import { handleCreateOrder } from "../utils";
import { Quotations } from "./Quotations";
import { AddQuotationModal } from "./addQuotation/AddQuotationModal";
import { getQuotationNumbers } from "./utils";

export const QuotationsSection = ({ editable }: { editable: boolean }) => {
  const { market, language } = useSettings();
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const [
    showUnLinkedQuotationOverlayItems,
    setShowUnLinkedQuotationOverlayItems,
  ] = useState<boolean>(false);

  const { opportunity } = useActiveProject();
  const { customer } = useCustomer(opportunity?.id);
  const quotationIds = getQuotationNumbers(opportunity);

  const { data: customerQuotations } = useQuotationSearchByCustomerId(
    customer?.partyId
  );

  const unassociatedQuotation = customerQuotations?.filter((res) => {
    return !quotationIds.includes(res?.quotationId);
  });

  return (
    <PaddedContainer>
      <SectionContainer>
        <ActionTitle
          title={`${
            quotationIds.length > 1
              ? t("label.quotations")
              : t("label.quotation")
          } (${quotationIds.length})`}
          action={
            editable && (
              <ActionTitleActions
                actions={[
                  {
                    id: "create-order-action",
                    icon: createNewIcon,
                    onClick: () => {
                      if (opportunity) {
                        handleCreateOrder(opportunity, market, language);
                        trackAnalytics("create_order");
                      }
                    },
                    text: t("action.create_order"),
                    title: t("action.create_order"),
                    iconOnly: true,
                  },
                  {
                    id: "add-quotation-action",
                    icon: plusIcon,
                    onClick: () => {
                      setIsOpen(true);
                      trackAnalytics("add_quotations");
                    },
                    text: t("action.add_quotations"),
                    title: t("action.add_quotations"),
                    iconOnly: true,
                  },
                ]}
              />
            )
          }
        />

        <Quotations editable={editable} />
      </SectionContainer>

      {hasItems(unassociatedQuotation) && (
        <ListView id="disassociated-quotation-list" size="small">
          <Line />
          <ListViewItem
            control={editable ? "navigational" : "default"}
            onClick={() => {
              setShowUnLinkedQuotationOverlayItems(true);
              setIsOpen(true);
              trackAnalytics("add_disassociated_quotation");
            }}
            title={
              unassociatedQuotation.length > 1
                ? t("prompt.found_multiple_quotations_not_associated", {
                    total: unassociatedQuotation.length,
                  })
                : t("prompt.found_one_quotation_not_associated")
            }
          />
        </ListView>
      )}
      {isOpen && (
        <AddQuotationModal
          isOpen={isOpen}
          closeModal={() => {
            setIsOpen(false);
            setShowUnLinkedQuotationOverlayItems(false);
          }}
          associatedQuotations={quotationIds}
          showUnLinkedQuotationOverlayItems={showUnLinkedQuotationOverlayItems}
        />
      )}
    </PaddedContainer>
  );
};
